import { all } from "redux-saga/effects";
import accountsSaga from "./accounts";
import tokensSaga from "./tokens";

export default function* plaidSagas() {
  yield all([accountsSaga(), tokensSaga()]);
}
